import React from "react";
import { Formik, Form } from "formik";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteCharges = ({
    setIsDeleteCharges,
    selectedData,
    deleteChargesLoading,
    deleteChargesMutate,
}) => {
    const handleDeleteSubmit = () => {
        deleteChargesMutate({ id: selectedData?.id });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteCharges}
            title="Charge Delete Confirmation"
        >
            <WarningText>
                Please confirm you want to delete the extra charges.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeleteCharges(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteChargesLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteChargesLoading ? "Deleting..." : "Delete Charge"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteCharges;
